// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, DispatchBeginReorder, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";

export const xDispatchBeginReorder: typeof DispatchBeginReorder = props => {
    throwErrorIfTesting();

    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
    // XNG-Changes
    if (!(props.parameter as any)?.orderLineId) {
        props.dispatch({
            type: "Pages/OrderDetails/BeginReorder",
        });
    }
};

export const xPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }

    // XNG-Changes:filter if we reordered only one order line
    const orderLines = order.value.orderLines ?? [];
    const orderLineId = (props.parameter as any)?.orderLineId;

    const linesToUse = orderLineId
        ? orderLines.filter((line: OrderLineModel) => line.id === orderLineId)
        : orderLines;

    props.apiParameter = {
        cartLines: linesToUse.map(
            (line: OrderLineModel) =>
            ({
                productId: line.productId,
                qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                unitOfMeasure: line.unitOfMeasure,
            } as CartLineModel),
        ),
    } as CartLineCollectionModel;
};

replaceInChain(chain, DispatchBeginReorder, xDispatchBeginReorder);
replaceInChain(chain, PopulateApiParameter, xPopulateApiParameter)